<div class="modals" [class.modals-show]="isModalGoodInformationShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <div class="flex-container-info-name">
    <ng-container>
      <div *ngIf="good_name">{{ good_name }}</div>
    </ng-container>
    &nbsp;
  </div>

  <div class="content-position">
    <ng-container>
      <div *ngIf="images?.length > 0; else noImagesBlock" class="card">
        <p-galleria [value]="images"
                    [showItemNavigators]="images.length > 1"
                    [showThumbnailNavigators]="false"
                    [responsiveOptions]="responsiveOptions"
                    [changeItemOnIndicatorHover]="false"
                    [containerStyle]="{ 'max-width': '450px'}" [numVisible]="5"
                    [showThumbnails]="images.length > 1">
          <ng-template pTemplate="item" let-item>
            <img [src]="item.itemImageSrc"
                 style="max-width: 400px; max-height: 500px; cursor: pointer"
                 (click)="openFullSizePhotoModal()"/>
          </ng-template>
          <ng-template pTemplate="thumbnail" let-item>
            <div class="grid grid-nogutter justify-content-center">
              <img [src]="item.thumbnailImageSrc" style="width: 40px; height: 40px; margin-top: 2px"/>
            </div>
          </ng-template>
        </p-galleria>
      </div>

      <ng-template #noImagesBlock>
        <div class="card" style="margin-top: 130px">
          <img
            src="data:image/jpeg;base64,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">
        </div>
      </ng-template>

      <div class="description-box-flex-container">
        <div class="description-box">
          <div *ngIf="articleString" class="article-info"><strong>АРТИКУЛ:</strong> {{ articleString }}</div>
          <div *ngIf="eanString" class="ean-info"><strong>EAN:</strong> {{ eanString }}</div>
          <div *ngIf="properties.length" class="description-title"></div>
          <ul>
            <li *ngFor="let prop of properties">
              <span class="name">{{ prop.name }}</span>
              <span class="description">{{ prop.value }}</span>
            </li>
          </ul>
        </div>
        <div *ngIf="propertiesDok && propertiesDok.length" class="description-box">
          <h1 class="title">Доп. характеристики</h1>
          <ul>
            <li *ngFor="let propDok of propertiesDok">
              <span class="name">{{ propDok.name }}</span>
              <span class="description">{{ propDok.value }}</span>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="link-btn-style">
    <button (click)="applicabilityInfo()">
      Отримати інформацію застосовності
    </button>
    <div class="info-missing"
         *ngIf="applicability && (!applicabilityData || applicabilityData.length <= 0)">
      В даний час немає інформації про застосовність
    </div>
    <div class="applicability-list"
         *ngIf="applicability && applicabilityData?.length > 0">
      <div>
        <input type="text"
               [(ngModel)]="searchText"
               (input)="filterApplicability()"
               placeholder="Пошук по: модель, рік, об'єм" class="mb20">
        <label class="search-icon" *ngIf="searchText === ''">
        </label>
        <label class="cross-clears-search-field" *ngIf="searchText !== ''" (click)="clearSearch()">
        </label>
      </div>
      <div class="table-responsive">
        <table>
          <thead>
          <tr>
            <th>Авто</th>
            <th>Рік</th>
            <th>Потужн. KW</th>
            <th>Потужн. PS</th>
            <th>Об'єм</th>
            <th>Кузов</th>
            <th>Код</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let app of filteredApplicabilityData">
            <tr>
              <td>
                {{ app.TYPEL }}
                <div *ngIf="app.TER_OF_USE">
                  <span class="limit-type">Обмеження: </span>
                  <span class="limit">{{ app.TER_OF_USE }}</span>
                </div>
              </td>
              <td>
                <span>{{ app.PCS_CI_FROM }}</span>
                <ng-container *ngIf="app.PCS_CI_FROM && app.PCS_CI_TO">
                  -
                </ng-container>
                <span>{{ app.PCS_CI_TO }}</span>
              </td>
              <td>{{ app.PCS_POWER_KW }}</td>
              <td>{{ app.PCS_POWER_PS }}</td>
              <td>{{ app.PCS_CAPACITY_TECH }}</td>
              <td>{{ app.PC_BODY_TYPE }}</td>
              <td>{{ app.PC_ENG_CODES }}</td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="link-btn-style" *ngIf="pdfs.length || urls.length">
    <button (click)="certificate()">
      Доп інфо
    </button>
    <ng-container *ngIf="isCertificateShow">
    <div *ngIf="pdfs.length" class="document-link">
      <ul>
        <li *ngFor="let pdf of pdfs">
          <div class="document-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"/>
            </svg>
          </div>
          <a [href]="pdf.url" target="_blank" rel="noopener noreferrer">
            {{ pdf.description }}
          </a>
        </li>
      </ul>
    </div>

    <div *ngIf="urls.length" class="document-link">
      <ul>
        <li *ngFor="let url of urls">
          <div class="document-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                d="M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0z"/>
            </svg>
          </div>
          <a [href]="url.safeMediaSource" class="pdf-link" target="_blank" rel="noopener noreferrer">
            {{ url.description }}
          </a>
        </li>
      </ul>
    </div>
    </ng-container>
  </div>

  <div class="description-text" [innerHTML]="description"></div>
</div>

<app-modal-img [images]="images"/>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>

